<template>
  <div class="new-campaign">
    <want-to-back
      v-if="wantToBack"
      @emitCancelSave="emitCancelSave"
      @emitSaveBefore="withoutSave"
    />
    <div class="arrow-section fixed w-full z-10">
      <the-header class="" />
    </div>
    <div
      class="arrow cursor-pointer pl-4"
      @click="checkIsAlreadySave"
    >
      <svg-icon
        name="ic-arrow-back"
        class="w-8 h-8"
        original
      />
    </div>
    <div class="flex justify-between w-full flex-section">
      <div class="edit-section overflow-y-scroll flex-1 w-1/2 p-6 bg-white">
        <canpaigns-infos
          :is-update="updateState"
          :campaign-for-u="editableCampaign"
          :is-update-image="isUpdateImage"
          @getCampaignName="getCampaignName"
          @getCampaignText="getCampaignText"
          @selectedImages="getSelectedImages"
          @choosedButton="choosedButton"
          @getAttachFileName="getAttachFileName"
          @getButtonLink="getButtonLink"
          @emitLikelyReach="getLikelyReach"
          @emitTotalCost="emitTotalCost"
          @successSave="successSave"
          @selectedFiles="selectedFiles"
        />
      </div>
      <div class="flex-1 preview-section ml-3">
        <div class="fixed-section fixed w-1/3">
          <div class="overflow-y-scroll overflow-y-scroll scroll-section">
            <div class=" p-6 pb-3 w-full bg-white">
              <new-campaign-preview
                :post-description="campaignText"
                :image-data="selectedImages.imageDataUrl"
                :chosed-button="campaignButton"
                :attach-file-name="attachFileName"
                :file-data="filesData"
              />
            </div>
            <div class="stat-section mt-6 p-6 bg-white w-full">
              <div class="flex w-full">
                <div class="flex-1 mr-1">
                  <h3 class="campaign-port font-normal text-xl">
                    {{ $t('portProba') }}
                    <span>
                      <svg-icon
                        slot="reference"
                        v-tippy
                        :content="$t('portPopup')"
                        name="ic-tooltip-icon"
                        class="w-6 h-6  ml-2 pt-1 top"
                        original
                      />
                    </span>
                  </h3>
                  <div class="amount-and-port  h-24 mt-2 rounded  text-2xl p-8 align-middle">
                    {{ nbrDoc }} <span class="text-base uppercase">Professionnels de santé</span>
                  </div>
                </div>
                <!-- Hiden in app cost -->
                <!-- <div class="flex-1 ml-1">
                  <h3 class="campaign-port font-normal text-xl">
                    {{ $t('totalCost') }}
                    <span>
                      <svg-icon
                        slot="reference"
                        v-tippy
                        :content="$t('totalCostPopup') + $t('totalCostPopupTwo')"
                        name="ic-tooltip-icon"
                        class="w-6 h-6  ml-2 pt-1"
                        original
                      />
                    </span>
                  </h3>
                  <div class="amount-and-port  h-24 mt-2 rounded  text-2xl p-8 align-middle">
                    € {{ totalCost }}
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CanpaignsInfos from '../../components/helper/rema-components/canpaigns-infos'
import NewCampaignPreview from '../../components/helper/rema-components/new-campaign-preview'
// import { firebaseDb } from '../../main'
// import { firebaseRef } from '../../rema-function/firebaseRef'
import { remaDefaultData } from '../../rema-function/remaDefaultData'
import firebaseStorage from '../../rema-function/firebaseStorage'
import ClickOutside from 'vue-click-outside'
import TheHeader from '../../components/the-header'
import WantToBack from '../../components/helper/rema-components/want-to-back'
import store from '../../store'
export default {
  name: 'Index',
  components: { WantToBack, TheHeader, NewCampaignPreview, CanpaignsInfos },
  directives: {
    ClickOutside
  },
  data () {
    return {
      campaignName: '',
      campaignText: '',
      attachFileName: '',
      selectedImages: {
        imagesReal: [],
        imageDataUrl: []
      },
      campaignButton: {},
      campaignButtonLink: '',
      editableCampaign: {},
      isUpdateImage: [],
      nbrDoc: 0,
      totalCost: 0,
      campaignId: '',
      updateState: false,
      isAlreadySave: false,
      wantToBack: false,
      filesData: []
    }
  },
  computed: {
    getCampaign: function () {
      return store.getters.getCurrentPost
    }
  },
  async created () {
    let vm = this
    if (this.$route.params.id !== 'new-campaign') {
      this.updateState = true
      let splitedArray = this.$route.params.id.split('&type=')
      // let campaignId = splitedArray[0]
      let campaingnType = splitedArray[1]
      // let ref = ''
      if (campaingnType === 'inactive') {
      //  ref = firebaseDb.ref(firebaseRef.mainsAdsFeeds)
      } else if (campaingnType === 'draft') {
      //  ref = firebaseDb.ref(firebaseRef.draftAds)
      } else {
      //  ref = firebaseDb.ref(firebaseRef.mainsAdsFeeds)
      }
      vm.editableCampaign = this.getCampaign
      /* await ref.child(campaignId).once('value', function (snapshot) {
        vm.editableCampaign = snapshot.val()
      }) */
      this.campaignName = this.editableCampaign.title
      this.campaignText = this.editableCampaign.textContent
      if (typeof this.editableCampaign.postButton !== 'undefined') {
        this.campaignButton = this.editableCampaign.postButton
      }
      if (typeof this.editableCampaign.attachment !== 'undefined') {
        this.fileData = this.editableCampaign.attachment.imagesUrl
      }
      if (typeof this.editableCampaign.attachment !== 'undefined') {
        this.attachFileName = this.editableCampaign.attachment.name
      }
      // this.totalCost = this.editableCampaign.
      // alert(JSON.stringify(vm.editableCampaign.attachment))
      if (campaingnType !== 'draft') {
        for (let i = 0; i < this.editableCampaign.imagesKeys.length; i++) {
          firebaseStorage.getPostImage(this.editableCampaign.key, this.editableCampaign.imagesKeys[i])
            .then((url) => {
              vm.FromUrlToDataURL(url, function (dataUrl) {
                //  alert(dataUrl)
                vm.selectedImages.imageDataUrl.push(dataUrl)
                vm.isUpdateImage.push(dataUrl)
              })
            })
        }
      } else {
        // alert(campaingnType)
        for (let i = 0; i < this.editableCampaign.imagesKeys.length; i++) {
          firebaseStorage.getDraftPostImage(this.editableCampaign.key, this.editableCampaign.imagesKeys[i])
            .then((url) => {
              vm.FromUrlToDataURL(url, function (dataUrl) {
                // alert(dataUrl)
                vm.selectedImages.imageDataUrl.push(dataUrl)
                vm.isUpdateImage.push(dataUrl)
              })
            })
        }
        // this.isUpdateImage = vm.selectedImages.imageDataUrl
      }
    }
  },
  methods: {
    getAttachFileName (answer) {
      this.attachFileName = answer
    },
    getCampaignName (answer) {
      this.campaignName = answer
    },
    getCampaignText (answer) {
      this.campaignText = answer
    },
    getSelectedImages (answer) {
      this.selectedImages = answer
    },
    choosedButton (answer) {
      this.campaignButton = answer
    },
    getButtonLink (answer) {
      this.campaignButtonLink = answer
    },
    getLikelyReach (answer) {
      this.nbrDoc = answer
    },
    emitTotalCost (answer) {
      this.totalCost = answer
    },
    convertToEuro (cout, deviseMoney) {
      if (deviseMoney.text === '€') {
        return cout
      } else {
        return Math.round(cout / remaDefaultData.baseEuro)
      }
    },
    FromUrlToDataURL (url, cb) {
      // This can be downloaded directly:
      var xhr = new XMLHttpRequest()
      xhr.responseType = 'blob'
      xhr.onload = function (event) {
        // var blob = xhr.response
        let reader = new FileReader()
        reader.onload = (e) => {
          cb(e.target.result)
          // alert('image _______: ' + e.target.result)
        }
        reader.readAsDataURL(xhr.response)
      }
      xhr.open('GET', url)
      xhr.send()
    },
    successSave () {
      this.isAlreadySave = true
    },
    checkIsAlreadySave () {
      if (!this.isAlreadySave && this.selectedImages.imageDataUrl.length > 0 && this.campaignText !== '' && this.campaignName !== '') {
        this.wantToBack = true
      } else {
        this.$router.push('/cards')
      }
    },
    emitCancelSave () {
      this.wantToBack = false
    },
    withoutSave () {
      this.wantToBack = false
      this.$router.push('/cards')
    },
    selectedFiles (answer) {
      this.filesData = answer
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/style/sass/variables";
.title-section {
  background-color: $Rema-Content-Background;;
}
  .new-campaign {
    width: 100%;
  }
  .divi {
    background-color: $Rema-Icon-Background;
  }
  .amount-and-port{
    background-color: $Rema-Content-Background;
  }
.popper {
  box-shadow: none;
  background-color: white;
  padding: 1rem;
  border-radius: 10px;
  color: black;
  font-size: .7rem;
  text-align: left;
}
  .fixed-section {
    position:fixed;
    overflow-y:scroll;
    overflow-x:hidden;
    height: 80%;
    width: 38%;
  }
  ::-webkit-scrollbar  {
    width: 0px;
  }
  .flex-section {
    width: 80%;
    margin: auto;
  }
  .new-campaign {
    background-color: $Rema-Content-Background;
  }
  .edit-section {
    margin-top: 2%;
  }
  .preview-section {
    margin-top: 1.8%;
  }
  .arrow {
    padding-top: 6%;
  }
</style>
